<template>
  <transition name="fade" mode="out-in">
    <div v-if="onConfirmationTab" class="ui inverted segment" key="confirmation">
      <div class="ui inverted header">
        <i class="tasks icon" />
        {{ localisation.generic.confirmation }}
      </div>

      <div class="ui small inverted header">
        {{ localisation.studyIdentifier.studyIdentifierLabel }}: {{ identifierField.toUpperCase() }}
      </div>
      <br>
      <button class="ui left floated tertiary circular button" @click="onConfirmationTab = false">{{ localisation.generic.back }}</button>
      <button class="ui right floated tertiary circular button" @click="submitIdentifier">{{ localisation.generic.confirm }}</button>
      <br>
      <br>
    </div>

    <div v-else class="ui inverted segment" key="form">
      <div class="ui inverted header">
        <i class="user icon" />
        {{ localisation.studyIdentifier.studyIdentifierTitle }}
      </div>

      <form class="ui form" @submit.prevent="validateIdentifier">
        <label>{{ localisation.studyIdentifier.studyIdentifierLabel }}</label>
        <div class="ui fluid input">
        <input type="text" v-model="identifierField" placeholder="MHx-xx-xxx">
        </div>
        <br>

        <error-messages v-if="hasError" :errors="errorMessages"/>
        <input class="ui right floated tertiary circular button" type="submit" :value="localisation.generic.next" style="border: 1px solid black">
      </form>
      <br>
      <br>

    </div>
  </transition>
</template>

<script>

import ErrorMessages from '@/components/ErrorMessages.vue'
import { mapActions } from 'vuex'
import { required, helpers } from 'vuelidate/lib/validators'
const VORSO_FORMAT = helpers.regex('VORSO_FORMAT', /^[mM][hH][0-9]-[0-9][0-9]-[0-9][0-9][0-9]$/)

export default {
  name: 'StudyIdentifier',
  components: {
    ErrorMessages
  },
  data () {
    return {
      identifierField: null,
      hasError: false,
      errorMessages: [],
      onConfirmationTab: false
    }
  },
  validations: {
    identifierField: {
      required,
      VORSO_FORMAT
    }
  },
  methods: {
    ...mapActions(['submitUserStudyIdentifier', 'updateUserStudyIdentifier']),

    validateIdentifier () {
      this.hasError = false
      this.errorMessages = []

      if (this.$v.$invalid) {
        this.hasError = true
        if (this.$v.identifierField.$invalid) {
          if (this.$v.identifierField.$model === null) {
            this.errorMessages.push('emptyStudyIdentifier')
          } else {
            this.errorMessages.push('invalidStudyIdentifier')
          }
        }
      } else {
        this.onConfirmationTab = true
      }
    },
    submitIdentifier () {
      let body = {
        'form_response': {
          'form_id': this.chosenStudy.identifierFormId,
          'hidden': {
            'userid': this.userId
          },
          'definition': {
            'id': this.chosenStudy.identifierFormId,
            'title': 'Vorso Pilot Identifier',
            'fields': [{
              'id': this.chosenStudy.identifierAttribute,
              'title': 'What is your study identifier?',
              'type': 'multiple_choice',
              'allow_multiple_selections': false,
              'allow_other_choice': false
            }]
          },
          'answers': [
            {
              'type': 'choice',
              'choice': {
                'label': this.identifierField.toUpperCase()
              },
              'field': {
                'id': 'vorso-pilot-identifier-id',
                'type': 'multiple_choice'
              }
            }
          ]
        }
      }

      this.submitUserStudyIdentifier(body).then(() => {
        this.updateUserStudyIdentifier({
          'vorso-pilot-identifier-id': this.identifierField.toUpperCase()
        })
      }).catch((error) => {
        this.hasError = true
        this.errorMessages.push('genericMessage')
        console.error(error)
      })
    }
  }
}

</script>

<style scoped>
label {
  color: white !important
}
</style>
